import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";

const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;

const SubscriptionManagement = ({
  subscription,
  onCancel,
  onReactivate,
  loading,
  isAdmin = false, // ⬅️ nuevo
}) => {
  // ⬅️ Si es admin, no mostramos el gestor de suscripción
  if (isAdmin) return null;

  if (!subscription?.has_subscription) return null;

  const isActive = subscription.status === "active";
  const isStripeActive = Boolean(subscription.stripe_active);
  const isCancelScheduled = Boolean(subscription.cancel_at_period_end);

  // Stripe -> current_period_end; Local -> purchase_date + 1 año
  const periodEndUnix =
    subscription.current_period_end ??
    (subscription.local_data?.purchase_date
      ? Math.floor(
          (new Date(subscription.local_data.purchase_date).getTime() +
            ONE_YEAR_MS) /
            1000
        )
      : null);

  const nextRenewal = periodEndUnix
    ? new Date(periodEndUnix * 1000).toLocaleDateString("es-ES")
    : "N/A";

  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle>Gestión de Suscripción</CardTitle>
      </CardHeader>

      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <span className="font-medium">Estado:</span>
            <div className="mt-1">
              <Badge variant={isActive ? "default" : "secondary"}>
                {isActive
                  ? isCancelScheduled
                    ? "Activa (cancelada al final del período)"
                    : "Activa"
                  : "Inactiva"}
              </Badge>
            </div>
          </div>

          <div>
            <span className="font-medium">Plan:</span>
            <div className="mt-1">Premium Anual</div>
          </div>

          <div>
            <span className="font-medium">Próxima renovación:</span>
            <div className="mt-1">{nextRenewal}</div>
          </div>

          <div>
            <span className="font-medium">Precio:</span>
            <div className="mt-1">€14.99/año</div>
          </div>
        </div>

        {/* CANCELAR: activa y NO programada — sirve para Stripe y local */}
        {isActive && !isCancelScheduled && (
          <Button
            variant="outline"
            onClick={onCancel}
            disabled={loading}
            aria-busy={loading}
            className="w-full bg-red-100 text-red-700 hover:bg-red-200 border-red-300"
          >
            {loading
              ? "Procesando..."
              : isStripeActive
              ? "Cancelar suscripción"
              : "Cancelar acceso Premium"}
          </Button>
        )}

        {/* REACTIVAR: solo si es Stripe, activa y ya programada para cancelar */}
        {isActive && isStripeActive && isCancelScheduled && (
          <>
            <div className="bg-yellow-50 p-3 rounded-md border border-yellow-200 text-sm text-yellow-800">
              La suscripción se cancelará el {nextRenewal}.
            </div>
            <Button
              onClick={onReactivate}
              disabled={loading}
              aria-busy={loading}
              className="w-full bg-yellow-500 hover:bg-yellow-600 text-white"
            >
              {loading ? "Procesando..." : "Reactivar suscripción"}
            </Button>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default SubscriptionManagement;
